module.exports = __webpack_public_path__ + "static/media/timeTable-profile.73bc64ac.svg";